import { render, staticRenderFns } from "./opv.vue?vue&type=template&id=07645453&scoped=true&"
import script from "./opv.vue?vue&type=script&lang=js&"
export * from "./opv.vue?vue&type=script&lang=js&"
import style0 from "./opv.vue?vue&type=style&index=0&id=07645453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07645453",
  null
  
)

export default component.exports